import { RefreshResultMessage } from "../types";
import { core } from "@/index";
import { applyRefreshResult } from "@/utils/tokenManager";
import { userFromMetadata } from "@/utils/userFromMetadata";

function navigateToApp(message: RefreshResultMessage): void {
  if (!message.appId || !message.deploymentId) return;

  const currentHash = globalThis.location.hash || "";
  if (currentHash.startsWith("#/_/app/")) return;

  let nav = `#/_/app/${message.appId}/${message.deploymentId}`;
  if (message.viewId) nav += `/${message.viewId}`;
  nav += "/";

  if (message.params && Object.keys(message.params).length > 0) {
    const params = new URLSearchParams();
    Object.entries(message.params).forEach(([k, v]) => params.set(k, String(v ?? "")));
    nav += "?" + params.toString();
  }

  if (currentHash !== nav) {
    globalThis.location.hash = nav;
  }
}

export const createRefreshResultHandler = () => {
  return async (message: RefreshResultMessage) => {
    const user = userFromMetadata(message.user ?? null);
    if (!user) {
      console.error("[RefreshResultHandler] Invalid or missing user (requires at least id)");
      return;
    }

    applyRefreshResult({
      dataToken: message.dataToken,
      user: message.user,
      viewPermissions: message.viewPermissions,
      expiresAt: message.expiresAt,
      appId: message.appId,
      deploymentId: message.deploymentId,
      orgId: message.orgId,
      eigenCustomerId: message.eigenCustomerId,
      showNavigation: message.showNavigation,
      showHeaderNavigation: message.showHeaderNavigation,
      showSidebarNavigation: message.showSidebarNavigation,
    });

    try {
      await core.fromToken(message.dataToken);
      core.user = user;
      core.authentication.user = core.user;
      core.authentication.identity = user.email;
      await core.save();
    } catch (error) {
      console.error("[RefreshResultHandler] Core update error:", error);
    }

    navigateToApp(message);
  };
};
